<template>
  <router-link
    :to="{ name: 'book.show', params: {...book} }"
    class="book"
  >
    <img class="book__thumb img-fluid" v-lazy="book.thumb_url" alt="asds">
    <div class="book__inner">
      <header class="book__header">
        <h1 class="book__name">{{ book.name }}</h1>
        <h2 class="book__author">{{ book.user.name }}</h2>
      </header>
    </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      book: { type: Object, required: true }
    }
  }
</script>

<style lang="scss" scoped>
  .book {
    display: block;
    position: relative;
    border-radius: 5px;

    &__thumb {
      transition: .4s all;
      border-radius: 5px;
    }

    &__inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    &__header {
      position: absolute;
      bottom: 0;
    width: 100%;
    padding: 15px;
      background: rgba(#000, .7);
      transform: translateY(100%);
      transition: .8s all;
      color: #fff;
      border-radius: 5px;
    }

    &__name {
      font-family: 'Poppins';
      font-size: 17px;
      font-weight: 700;
      margin-bottom: 3px;
    }

    &__author {
      font-size: 15px;
      color: #818181;
    }

    &:hover &__header {
      transform: translateY(-8px);
      transition: .28s all;
    }

    &:hover &__thumb {
      box-shadow: 2px 2px 20px rgba(#000, .4);
      transform: translateY(-8px);
    }
  }
</style>